import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/terms.scss";

function Terms() {
  useEffect(() => {
    document.title = `General conditions | ${siteConfig.brandName}`;
  }, []);

  return (
    <main className="policy-page terms-page">
      <header className="policy-hero">
        <nav aria-label="Breadcrumb">
          <Link to="/">Home</Link>
          <span>/</span>
          <span>General conditions</span>
        </nav>
        <p className="eyebrow">Demo store conditions</p>
        <h1>General conditions</h1>
        <p>
          Clear expectations for browsing, ordering and using this demonstration
          storefront.
        </p>
      </header>
      <div className="policy-layout">
        <aside aria-label="On this page">
          <a href="#terms-scope">Scope</a>
          <a href="#terms-products">Products</a>
          <a href="#terms-orders">Orders</a>
          <a href="#terms-delivery">Delivery</a>
          <a href="#terms-returns">Returns</a>
          <a href="#terms-liability">Liability</a>
        </aside>
        <article>
          <section id="terms-scope">
            <p className="eyebrow">Article 01</p>
            <h2>Scope and operator</h2>
            <p>
              These conditions describe the intended customer experience for{" "}
              {siteConfig.brandName}, operated by{" "}
              {siteConfig.business.legalName} at{" "}
              {siteConfig.contact.address}. The current project is a front-end
              demonstration and does not create a binding sale, charge a payment
              method or dispatch physical goods.
            </p>
          </section>
          <section id="terms-products">
            <p className="eyebrow">Article 02</p>
            <h2>Products and pricing</h2>
            <p>
              Product names, descriptions, availability and prices are presented
              for demonstration. Photography and descriptions are original
              project assets. Prices include the configured currency
              presentation and may be changed before a production launch.
            </p>
          </section>
          <section id="terms-orders">
            <p className="eyebrow">Article 03</p>
            <h2>Orders and payment</h2>
            <p>
              An order confirmation generated by this interface proves only that
              the demo flow completed. No payment data is sent or retained. A
              live store must connect a certified payment provider and issue a
              separate commercial confirmation.
            </p>
          </section>
          <section id="terms-delivery">
            <p className="eyebrow">Article 04</p>
            <h2>Delivery</h2>
            <p>
              Displayed delivery estimates are indicative. In a live store,
              timing begins only after an order is accepted and depends on
              destination, stock and carrier conditions. See the{" "}
              <Link to="/shipping">delivery page</Link>.
            </p>
          </section>
          <section id="terms-returns">
            <p className="eyebrow">Article 05</p>
            <h2>Returns</h2>
            <p>
              The intended policy allows returns of unworn items with original
              labels within {siteConfig.returns.windowDays} days. Return
              carriage is normally paid by the customer and exchanges are
              handled by placing a new order. See{" "}
              <Link to="/returns">returns</Link>.
            </p>
          </section>
          <section id="terms-liability">
            <p className="eyebrow">Article 06</p>
            <h2>Liability and contact</h2>
            <p>
              This prototype is provided for design and development evaluation.
              Production legal terms, tax rules, consumer rights, accessibility
              obligations and data processing agreements must be reviewed for
              the launch markets. Contact{" "}
              <a href={`mailto:${siteConfig.contact.email}`}>
                {siteConfig.contact.email}
              </a>
              .
            </p>
          </section>
        </article>
      </div>
    </main>
  );
}

export default Terms;
